import React from 'react'
import { useState, useEffect, useRef } from 'react';
import { Link, useHistory } from 'react-router-dom';
import Logo from './img/logo/TC-LOGO.png';
import './ChangePassword.css';
import axios from 'axios';
import { useStateValue } from './StateProvider';

function ChangePassword() {

  const [{}, dispatch] = useStateValue();
  const [email, setEmail] = useState('');
  const [counter, setCounter] = useState(0);
  const history = useHistory();

  function useInterval(callback, delay) {

   const savedCallback = useRef();
  
    // Remember the latest callback.
    useEffect(() => {
      savedCallback.current = callback;
    }, [callback]);
  
    // Set up the interval.
    useEffect(() => {
      let id = setInterval(() => {
        savedCallback.current();
      }, delay);
      return () => clearInterval(id);
    }, [delay]);

    
  }

  useInterval(() => {
    setCounter(counter + 1);
  }, 1000);

  const onSubmit = () =>{

    if(!isValidEmail(email)){
        document.getElementById("307").style.display = "block";
        document.getElementById("__307").style.border = "1px solid red";
        setCounter(0);
    }
    else{
        axios
            .get('https://toycityzimbabwe.com/backend/checkEmail.php', {params: {email}} )
            .then(res => {
                validUser(res.data)
            })
            .catch( error => {
                console.log(error)
            });
    }
  }

  useEffect(() => {
    if(counter === 5){
        document.getElementById("307").style.display = "none";
        document.getElementById("901").style.display = "none";
    }
  }, [counter])

  function isValidEmail(email) {
    return /\S+@\S+\.\S+/.test(email);
  }

  function validUser(user){

    if(user.length === 0){
        document.getElementById("901").style.display = "block";
        document.getElementById("__307").style.border = "1px solid red";
        setCounter(0);
    }else{
        axios
            .get('https://toycityzimbabwe.com/backend/sendEmail.php', {params: { email }} )
            .then(res => {    
                
            })
            .catch( error => {
                console.log(error)
            });

        dispatch({
          type: 'SET_EMAIL',
          email: email
        })
            
        history.push('/changepassword-code-verification');
    }
  }

  return (
    <div className='c__pass'>
        <div className='c__pass_logo'>
            <Link to='/'>
                <img className='logo' src={Logo}/>
            </Link>    
        </div>
        <div className='c__pass_text'>
            <h3>Change Password</h3>
        </div>
        <div className='c__pass__blueSide'></div>
        <div className='c__pass__center'>
            <input type="text" id='__307' value={email} onChange={e => setEmail(e.target.value)} placeholder="Email"></input>
            <div className='c__pass__error' id='307'><label id='424'>Email invalid</label></div>
            <div className='c__pass__error' id='901'><label id='424'>Email incorrect</label></div>
            <button onClick={onSubmit}>Verify email</button>
            <div><p>Create account?</p><Link to="/signup"><p className='signin_goto'>&nbsp;Sign Up</p></Link></div>
        </div>
    </div>
  )
}

export default ChangePassword